import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { PROFILE_DETAILS_URL } from "../../const/URL.const";
import { IReduxAppState } from "../../reducers";

interface IDisableComponent {
    pageKey?: string;
    children: any;
    navigateURL?: string;
}

/**using the disable routes router it disables the children component and navigates back to  */
export function DisableRouteComponent({
    // pageKey,
    children,
    navigateURL = PROFILE_DETAILS_URL
}: IDisableComponent) {
    const disabledRoutes = useSelector((state: IReduxAppState) => state.disabledRoutes);
    const pageKey = useSelector((state: IReduxAppState) => state.sidebar.position.key);
    const history = useHistory();

    useEffect(() => {
        if (pageKey !== undefined) {
            if (disabledRoutes.indexOf(pageKey) > -1) {
                history.push(navigateURL);
            }
        }
    }, [disabledRoutes, pageKey, navigateURL, history]);

    return children!;
}